import React from 'react';
import IndexArquivoDocumento from '../ArquivoDocumento/Index';
export default function Index() { return <IndexArquivoDocumento tipo />; }
